import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BestBetterDeal, BestBetterDealViewModel, BestDealFlag } from '@shared/models/best-better-deal-view.model';
import { bestBetterDealAdapter } from '@shared/store/best-better-deals/best-better-deals.reducer';
import { BestBetterDealState } from '@shared/store/best-better-deals/best-better-deals.state';

const { selectAll, selectEntities } = bestBetterDealAdapter.getSelectors();
export const selectBestBetterDealsState = createFeatureSelector<BestBetterDealState>('bestBetterDeals');

export const selectIsLoadingBestBetterDeals = createSelector(
  selectBestBetterDealsState,
  (state: BestBetterDealState): boolean => state.loading,
);

export const selectBestBetterDealsEntities = createSelector(selectBestBetterDealsState, (bestBetterDeal: BestBetterDealState) =>
  selectEntities(bestBetterDeal),
);

export const selectBestBetterDeals = createSelector(selectBestBetterDealsEntities, (bestBetterDealEntities): BestBetterDealViewModel[] =>
  Object.values(bestBetterDealEntities),
);

export const selectBestBetterDealsByMortgageId = (mortgageId: string) =>
  createSelector(
    selectBestBetterDealsState,
    (bestBetterDeal: BestBetterDealState): BestBetterDeal[] => bestBetterDeal?.entities[mortgageId]?.bestDeals,
  );

export const selectBiggestSavingDealByMortgageId = (mortgageId: string) =>
  createSelector(
    selectBestBetterDealsState,
    (bestBetterDeal: BestBetterDealState): BestBetterDeal =>
      bestBetterDeal?.entities[mortgageId]?.bestDeals?.find((d) => d.flag == BestDealFlag.BIGGEST_STAVING),
  );

// TODO: remove, I keep the code just for support OLD_Modules
export const selectBestBetterDealsOld = createSelector(selectBestBetterDealsState, (state: BestBetterDealState): any[] => selectAll(state));

// TODO: remove, I keep the code just for support OLD_Modules ($comparisonHistoryColumns, $infoCardState OLD_Dashboard)
export const selectFirstBestBetterDeal = createSelector(selectBestBetterDealsOld, (bestBetterDeals: any[]): any => {
  return bestBetterDeals.find((bestBetterDeal) => bestBetterDeal.bestDealComparisonPeriod) ?? null;
});
